import React, { useState, useCallback } from 'react';
import Button from '@material-ui/core/Button';
import EditIcon from '@material-ui/icons/Edit';
import {
  Edit,  TabbedForm,  TextInput,  DateInput,  ReferenceInput,  SelectInput,  required,  BooleanInput,  FormTab,  useRefresh,  ReferenceManyField, ReferenceField, Datagrid,NumberInput,  TextField,
  DateField,BooleanField} from "react-admin";
import { CreateToolbar } from "../../CreateToolbar";
import VSDeleteButton from "../../VSDeleteButton";
import { useStyles } from "../../formStyles";
import { Drawer } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import TPAConfigEdit from "./TPAConfigEdit";
import CDeleteButton from "../../common/CDeleteButton";
import TPAConfigCreate from "./TPAConfigCreate";
import InsurerConfigCreate from "./InsurerConfigCreate";
import HospitalRealDetCreate from "./HospitalRealDetCreate";
import HospitalDocumentsCreate from "./HospitalDocumentsCreate";
import ConfigCreate from './ConfigCreate';
import EditFOPayment from './EditFOPayment';
import CreateFOPayment from './CreateFOPayment';

const myStyles = makeStyles(theme => ({
  root: {
      display: 'flex',
  },
  list: {
      flexGrow: 1,
      transition: theme.transitions.create(['all'], {
          duration: theme.transitions.duration.enteringScreen,
      }),
      marginRight: 0,
  },
  listWithDrawer: {
      marginRight: 300,
  },
  drawerPaper: {
      zIndex: 100,
      marginTop: 50,
      width: 650,
  },
}));

const DisplayFileLink = (props) => {
  let { record } = props;

  if (record.docUrl && record.docUrl.length > 0)
    return (
      <a href={record.docUrl}>View File</a>
    )
  else {
    return null
  }
}
export const userStyles = makeStyles(theme => ({
  main: {
      display: "flex",
      justifyContent: "space-between",
  },
  item: {
      width: 100,
  },
}));

export const TPAEditButton = props => {
  const setHospitalDetId = () => {
      props.setHospitalDetEdit(props.record.id);
  }
  return (
      <Button
          color="secondary" disableElevation
          size="medium"
          
          onClick={setHospitalDetId}
          startIcon={<EditIcon />}>Edit</Button>
  )
};

export const HospitalEdit = (props) => {
  let propsObj = { ...props };
  if (propsObj.permissions) {
    let resourcename = `/${props.resource}`;
    let myPermissions = propsObj.permissions.filter(item => item.NavigateUrl.toLowerCase().trim() == resourcename);
    if (myPermissions.length > 0) {
      let p = myPermissions[0];
      propsObj.hasList = (p.View == 1) ? true : false;
      propsObj.hasShow = (p.View == 1) ? true : false;
      propsObj.hasEdit = (p.Edit == 1) ? true : false;
      propsObj.hasDelete = (p.Delete == 1) ? true : false;
      propsObj.hasCreate = (p.Create == 1) ? true : false;
      propsObj.hasExport = (p.Export == 1) ? true : false;
    }
  }

  const classes = useStyles({});
  const [isaddTpa, setIsAddTpa] = useState(false);
  const [isaddConfig, setIsAddConfig] = useState(false);
  const [isaddFoConfig, setIsAddFoConfig] = useState(false);
        const [isEditFoConfig, setIsEditFoConfig] = useState(false);
        const [selectedRecord, setSelectedRecord] = useState(null);
  const [isaddInsurer, setIsAddInsurer] = useState(false);
  const [isaddRealisation, setIsAddRealisation ] = useState(false);
  
  const [isEditTpa, setIsEditTpa] = useState(false);
  const [hospitalDetEditId, setHospitalDetEditId] = useState(0);
  const [isaddDocuments, setIsAddDocuments] = useState(false);
  const myclasses = myStyles({});
  const refresh = useRefresh();
  const setgridRecordEdit = (id) => {
   
    setHospitalDetEditId(id);
    setIsEditTpa(true);
}
const closeEdit = () => {
  setIsAddTpa(false);
  setIsAddConfig(false);
  setIsEditTpa(false);
  setIsAddDocuments(false);
  setIsAddInsurer(false);
  setIsAddRealisation(false);
  setIsAddFoConfig(false);
  setIsEditFoConfig(false);
  refresh();
}


const onCancel = () => {
  setIsAddTpa(false);
  setIsAddConfig(false);
  setIsEditTpa(false);
  setIsAddDocuments(false);
  setIsAddInsurer(false);
  setIsAddRealisation(false);
  setIsAddFoConfig(false);
  setIsEditFoConfig(false);
}

  const handleClose = useCallback(() => {
    setIsAddTpa(false);
    setIsAddConfig(false);
    isaddFoConfig(false);
  isEditFoConfig(false);
    //setIsAccountServiceAdd(false);
}, []);
 const Edit_Button = (props) => {
    return (
        <Button variant="contained"
            onClick={() => {
                props.onClick(props.record.id);
            }}
            color="primary">
            Edit 
        </Button>
    )
}

  return (
    <React.Fragment>
    <Edit title="Hospital Edit" {...propsObj}>
   
   <TabbedForm variant="outlined" redirect="list" toolbar={<CreateToolbar {...props} />}>
          <FormTab value="DETAILS" label="Hospital Detail">
            <TextInput source="code" label="Code" validate={[required()]} formClassName={classes.one_three_input} disabled={true} initialValue={"Auto Generate"} />
            <DateInput source="dealDate" label="Ent. Date" validate={[required()]} formClassName={classes.two_three_input} />
            <DateInput source="openDate" label="Open Date" validate={[required()]} formClassName={classes.last_three_input} />

            <TextInput source="name" label="Name" validate={[required()]} formClassName={classes.one_three_input} />
            <TextInput source="phoffice" label="Phone(Off)."  formClassName={classes.two_three_input} />
            <TextInput source="email" label="email" formClassName={classes.last_three_input} />
            
            <TextInput source="phmobile" label="Mobile" formClassName={classes.one_three_input} />
            <TextInput source="tin" label="TIN" formClassName={classes.two_three_input} />
            <TextInput source="cstNo" label="GST Number" formClassName={classes.last_three_input} />

            <TextInput source="tpt" label="TPT" formClassName={classes.one_three_input} />
            <TextInput source="licno" label="LIC No" formClassName={classes.two_three_input} />
            <TextInput source="panno" label="PAN Number"  formClassName={classes.last_three_input} />

            <ReferenceInput label="Handle By" source="employeeId" reference="employees" formClassName={classes.one_three_input} sort={{ field: 'name', order: 'ASC' }} >
              <SelectInput optionText="name" validate={[required()]} />
          </ReferenceInput>


          <TextInput source="state" label="State" validate={[required()]} formClassName={classes.two_three_input} />
          <ReferenceInput label="Area" source="areaId" reference="areas" formClassName={classes.last_three_input} sort={{ field: 'name', order: 'ASC' }}>
              <SelectInput optionText="name" />
          </ReferenceInput>
          <TextInput source="city" label="City" validate={[required()]} formClassName={classes.one_three_input} />
          
          <TextInput source="add1" label="Address 1" validate={[required()]} formClassName={classes.two_three_input} />
          <TextInput source="add2" label="Address 2" formClassName={classes.last_three_input} />

          <TextInput source="add3" label="Address 3"  formClassName={classes.one_three_input} />
          <TextInput source="pincode" label="Pincode" validate={[required()]} formClassName={classes.two_three_input} />
          <TextInput source="remarks" label="Remarks"  formClassName={classes.last_three_input} />

   
          <BooleanInput source="isCenteralHosp" label="IGST Invoice" initialValue={false} formClassName={classes.one_three_input} />
          <ReferenceInput label="Tax Type" perPage={5000} source="taxtTypeID" filter={{ type: 'TT' }} reference="lookups" formClassName={classes.two_three_input}>
                    <SelectInput optionText="name"  />
          </ReferenceInput>
          <NumberInput  label="Tax Percentage"  source="taxPercentage"   formClassName={classes.two_three_input} /> 

          
              
          <BooleanInput source="isCeLic" label="Is CE License" initialValue={true} formClassName={classes.one_three_input} />
          <BooleanInput source="isFireLic" label="Is Fire Lic" initialValue={true} formClassName={classes.two_three_input} />
          <BooleanInput source="isPndt" label="Is PNDT" initialValue={true} formClassName={classes.last_three_input} />

          <BooleanInput source="isPollut" label="Is Pollution" initialValue={true} formClassName={classes.one_three_input} />
          <BooleanInput source="isBioWaste" label="Is Biomedical Waste" initialValue={true} formClassName={classes.two_three_input} />
          <BooleanInput source="isPpn" label="Is PPN" initialValue={true} formClassName={classes.last_three_input} />

          <BooleanInput source="isRohiniId" label="Is Rohini Id" initialValue={true} formClassName={classes.one_three_input} />
          <BooleanInput source="isNabh" label="isBioWaste" initialValue={true} formClassName={classes.two_three_input} />
          <BooleanInput source="isActive" label="Active" initialValue={true} formClassName={classes.last_three_input} />
     
          <TextInput source="cpName1" label="Contact Person 1"  formClassName={classes.one_three_input} />
          <TextInput source="cpMob1" label="Contact Person 1 Mobile" formClassName={classes.two_three_input} />
          <TextInput source="cpRes1" label="Contact Person 1 ResiID"  formClassName={classes.last_three_input} />

          <TextInput source="cpName2" label="Contact Person 2"  formClassName={classes.one_three_input} />
          <TextInput source="cpMob2" label="Contact Person 2 Mobile" formClassName={classes.two_three_input} />
          <TextInput source="cpRes2" label="Contact Person 2 ResiID"  formClassName={classes.last_three_input} />
          
          <TextInput source="cpName3" label="CE License No."  formClassName={classes.one_three_input} />
          <TextInput source="cpMob3" label="Fire License No." formClassName={classes.two_three_input} />
          <TextInput source="cpRes3" label="ROHINI ID"  formClassName={classes.last_three_input} />
          

          <TextInput source="cpName4" label="CE License Validity"  formClassName={classes.one_three_input} />
          <TextInput source="cpMob4" label="FIRE License Validity" formClassName={classes.two_three_input} />
          <TextInput source="cpRes4" label="ROHINI ID Validity"  formClassName={classes.last_three_input} />

          <TextInput source="cpName5" label="PPN Validity"  formClassName={classes.one_three_input} />
          <TextInput source="cpMob5" label="Remarks 1" formClassName={classes.two_three_input} />
          <TextInput source="cpRes5" label="Remarks 2"  formClassName={classes.last_three_input} />
              
          </FormTab>
          <FormTab label="TPA ">
                        <Button variant="contained" onClick={() => { setIsAddTpa(true); }}
                            color="secondary">
                            Add TPA 
                            </Button>
                        <ReferenceManyField fullWidth={true}
                            addLabel={false}
                            sort={{ field: 'id', order: 'ASC' }}
                            reference="hospital-dets"
                            target="hospitalId">
                            <Datagrid>
                                <VSDeleteButton {...props} />
                                {/* <TPAEditButton setHospitalDetEdit={setgridRecordEdit} /> */}
                                <ReferenceField link={false} label="TPA" source="tpaid" reference="tpas" fullWidth={true} >
                                    <TextField source="name" />
                                </ReferenceField>
                                <TextField fullWidth={true} source="isTieUp" label="Tie-Up" />
                                <TextField fullWidth={true} source="empanelled" label="Empanelled" />
                                <DateField fullWidth={true} source="agrmtFDt" label="Agrmnt. Date From" locales="fr-FR"/>
                                <DateField fullWidth={true} source="agrmtTDt" label="Agrmnt. Date To" locales="fr-FR"/>
                                <TextField fullWidth={true} source="remarks" label="Remarks" />
                            </Datagrid>
                        </ReferenceManyField>
                    </FormTab>
    <FormTab label="Insurer ">
                        <Button variant="contained" onClick={() => { setIsAddInsurer(true); }}
                            color="secondary">
                            Add Insurer
                            </Button>
                        <ReferenceManyField fullWidth={true}
                            addLabel={false}
                            sort={{ field: 'id', order: 'ASC' }}
                            reference="hospital-ins-dets"
                            target="hospitalId">
                            <Datagrid>
                                <VSDeleteButton {...props} />
                                {/* <TPAEditButton setHospitalDetEdit={setgridRecordEdit} /> */}
                                <ReferenceField link={false} label="Insurer" source="insurerid" reference="insurers" fullWidth={true} >
                                    <TextField source="name" />
                                </ReferenceField>
                                <TextField fullWidth={true} source="isTieUp" label="Tie-Up" />
                                <TextField fullWidth={true} source="empanelled" label="Empanelled" />
                                <DateField fullWidth={true} source="agrmtFDt" label="Agrmnt. Date From" locales="fr-FR"/>
                                <DateField fullWidth={true} source="agrmtTDt" label="Agrmnt. Date To" locales="fr-FR"/>
                                <TextField fullWidth={true} source="remarks" label="Remarks" />
                            </Datagrid>
                        </ReferenceManyField>
                    </FormTab>
    <FormTab label="Realisation Detail ">
                        <Button variant="contained" onClick={() => { setIsAddRealisation(true); }}
                            color="secondary">
                            Add Realisation Config
                            </Button>
                        <ReferenceManyField fullWidth={true}
                            addLabel={false}
                            sort={{ field: 'id', order: 'ASC' }}
                            reference="hospital-real-dets"
                            target="hospitalId">
                            <Datagrid>
                                <VSDeleteButton {...props} />
                                
                                <TextField fullWidth={true} source="tatindays" label="Tat In Day" />
                                <TextField fullWidth={true} source="billingPercentage" label="Billing Percentage" />
                                <TextField fullWidth={true} source="remarks" label="Remarks" />
                            </Datagrid>
                        </ReferenceManyField>
                    </FormTab>
   <FormTab label=" Documents">
            <div style={{ flex: 1 }}>
              <Button onClick={() => { setIsAddDocuments(true); }}>Add New</Button>
              
            </div>

            <ReferenceManyField fullWidth={true}
              addLabel={false}
              sort={{ field: 'id', order: 'ASC' }}
              reference="hospital-docs"
              target="hospitalId">
              <Datagrid>
                <CDeleteButton {...props} />
                {/* <TextField label="ITP" source="itp" />
                <TextField label="BillNo" source="billNo" /> */}
                <DateField showTime={true} label="createdDate" source="createdDate" locales="fr-FR"/>
                {/* <TextField label="Document Type" source="docType" /> */}
                <ReferenceField source="typeId" reference="lookups" label="Type"  link={false}>
                  <TextField source="name" />
                </ReferenceField>
                <TextField label="Remarks" source="remarks" />
                <DisplayFileLink label="Document URL" source="docUrl" />
                {/* <UploadDocument onClick={(record) => { setIsEditDocumentRecord(record); setIsEditDocuments(true); }} label="Upload Document" /> */}
              </Datagrid>
            </ReferenceManyField>
          </FormTab>
        <FormTab label="Configration ">
                        <Button onClick={() => { setIsAddConfig(true); }}
                          color="secondary">
                          Add Config
                        </Button>
                        <ReferenceManyField fullWidth={true}
                          addLabel={false}
                          sort={{ field: 'id', order: 'ASC' }}
                          reference="hospital-inv-dets"
                          target="hospitalId">
                          <Datagrid>
                            <VSDeleteButton {...props} />
                            {/* <TPAEditButton setHospitalDetEdit={setgridRecordEdit} /> */}
                            <ReferenceField link={false} label="Claim Type" source="claimTypeId" reference="lookups" fullWidth={true} >
                              <TextField source="name" />
                            </ReferenceField>
                            <TextField fullWidth={true} source="tatindays" label="Tat in days" />
                            <TextField fullWidth={true} source="billingPercentage" label="Billing Percentage" />
                            <TextField fullWidth={true} source="billingAmount" label="Billing Amount" />
                            <TextField fullWidth={true} source="professionalFee" label="Professional Fee" />
                            <ReferenceField link={false} label="Incentive Type" source="incentiveType" reference="lookups" fullWidth={true} >
                              <TextField source="name" />
                            </ReferenceField>
                            <TextField fullWidth={true} source="incentiveAmt" label="Incentive Amt" />
                            <ReferenceField link={false} label="other Charges Type" source="otherChargesType" reference="lookups" fullWidth={true} >
                              <TextField source="name" />
                            </ReferenceField>
                            <TextField fullWidth={true} source="otherCharges" label="Other Charges Amt" />
                            <TextField fullWidth={true} source="remarks" label="Remarks" />
                            <TextField fullWidth={true} source="other" label="Other" />
            
                          </Datagrid>
                        </ReferenceManyField>
                      </FormTab>

                      <FormTab label="FO Fee Configration ">
                                                              <Button onClick={() => { setIsAddFoConfig(true); }}
                                                                color="secondary">
                                                                Add Config
                                                              </Button>
                                                              <ReferenceManyField fullWidth={true}
                                                                addLabel={false}
                                                                sort={{ field: 'id', order: 'ASC' }}
                                                                reference="hospital-fo-fee-dets"
                                                                target="hospitalId">
                                                                <Datagrid>
                                                                  <VSDeleteButton {...props} />
                                                                  
                                                                  {<Edit_Button label="Modify" {...props} onClick={(id) =>{
                                                            setIsEditFoConfig(true);
                                                            setSelectedRecord(id);
                                                          }} />}
                                                          
                                                                  <ReferenceField link={false} label="Policy Type" source="policyTypeId" reference="lookups" fullWidth={true} >
                                                                    <TextField source="name" />
                                                                  </ReferenceField>
                                                                  <BooleanField fullWidth={true} source="isInsured" label="Insured"/>
                                                                  <BooleanField fullWidth={true} source="isHospitalised" label="Hospitalised"/>
                                                                  <BooleanField fullWidth={true} source="iscompleted" label="Completed"/>
                                                                  <TextField fullWidth={true} source="professionalFee" label="Professional Fee" />
                                                                  <TextField fullWidth={true} source="remarks" label="Remarks" />
                                                       ,
                                                    
                                                                </Datagrid>
                                                              </ReferenceManyField>
                                                            </FormTab>
        </TabbedForm>


    </Edit>
    <Drawer
     anchor="right"
     onClose={handleClose}
     classes={{ paper: myclasses.drawerPaper, }}
     open={isaddTpa || isaddConfig ||isaddFoConfig || isEditFoConfig|| isaddDocuments || isaddInsurer || isaddRealisation} >
       {isaddTpa &&  <TPAConfigCreate
                      onClose={closeEdit}
                      onCancel={onCancel}
                      hospitalId={props.id}
                      {...props} />}
      {isaddConfig &&  <ConfigCreate
                      onClose={closeEdit}
                      onCancel={onCancel}
                      id={props.id}
                      {...props} />}
       {isaddInsurer &&  <InsurerConfigCreate
                      onClose={closeEdit}
                      onCancel={onCancel}
                      hospitalId={props.id}
                      {...props} />}
       {isaddRealisation &&  <HospitalRealDetCreate
                      onClose={closeEdit}
                      onCancel={onCancel}
                      hospitalId={props.id}
                      {...props} />}
       {isaddDocuments && <HospitalDocumentsCreate
                    onClose={closeEdit}
                    onCancel={onCancel}
                    hospitalId={props.id}
                    {...props}   />}
                    {isaddFoConfig && <CreateFOPayment
                              onClose={closeEdit}
                              onCancel={onCancel}
                              id={props.id}
                              {...props} />}
                              {isEditFoConfig && <EditFOPayment
                              onClose={closeEdit}
                              onCancel={onCancel}
                              selectedId={selectedRecord}
                              {...props} />}
       </Drawer>
 
</React.Fragment>
  );
};
